import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { Link } from 'react-router-dom';
import Loading from '../Loader/Loader';
import { withTranslation } from 'react-i18next';
import {
    getPortalSettings,
    checkMarketSourceGuid
} from "../../redux/actions/UserActions";

class ValidateMarketSource extends Component {
    constructor(props) {
        super(props)
        this.state = {
            portallogo: localStorage.getItem("publicportallogo"),
            showInvalid: false
        }
    }

    componentDidMount() {
        localStorage.clear();
        this.props.getPortalSettings();
        const marketSourceId = this.props.match.params.id;
        const url = window.location.href;
        const queryParams = `?Id=${marketSourceId}&url=${url}`;

        this.props.checkMarketSourceGuid(queryParams);
    }

    componentDidUpdate(prevProps) {
        const { marketsourcedata, match, history } = this.props;
        if (prevProps.marketsourcedata !== marketsourcedata && marketsourcedata) {
            if (marketsourcedata.Success) {
                localStorage.setItem('isvalid', 'true');
                localStorage.setItem('marketSourceId', match.params.id);

                history.push({
                    pathname: '/CreateClient',
                    state: {
                        marketSourceId: match.params.id,
                        subMarketSourceValues: marketsourcedata.subMarketSourceValues
                    }
                });
            } else {
                this.setState({ showInvalid: true });
            }
        }
         if ((prevProps.portallogo && localStorage.getItem('publicportallogo')) && prevProps.portallogo !== localStorage.getItem('publicportallogo')) {
            this.setState({
                portallogo: localStorage.getItem('publicportallogo')
            });
        }
    }
    render() {
        const { fetching, error, t } = this.props;
        const { showInvalid } = this.state;

        if (showInvalid) {
            return (
                <div style={{ background: "#eceff0", minHeight: '100vh' }}>
                    <div className="full-background pt-4">
                        <div className={`header-${window.globalConfig.CustomerName} container-fluid`}>
                            <div className="row align-items-center">
                                <div className="col-6 d-flex">
                                    <div className="logo">
                                        <Link to="/">
                                            <img
                                                src={this.state.portallogo}
                                                height="100%"
                                                alt="Portal Logo"
                                                onError={(e) => e.target.style.display = 'none'}
                                            />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{
                            marginTop: '5%',
                            textAlign: "center",
                            fontSize: '25px',
                            color: "red",
                            padding: '0 20px'
                        }}>
                            <p>{t('caseDetails.invalidcaseuser')}</p>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div>
                {fetching && !error && <Loading />}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    portalSettings: state.user.portalSettings,
    marketsourcedata: state.user.marketsourcedata,
    fetching: state.user.fetching,
    error: state.error.isError,
});

const mapDispatchToProps = {
    getPortalSettings,
    checkMarketSourceGuid
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(
        withTranslation('common')(ValidateMarketSource)
    )
);
